import styled from "styled-components";

export const NotificationsContainer = styled.div`
  position: relative;
`;

export const TriggerWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const UnreadBadge = styled.span`
  position: absolute;
  top: 36px;
  right: 14px;
  min-width: 16px;
  height: 16px;
  padding: 0 3px;
  background: #e53e3e;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
  border-radius: 8px;
  pointer-events: none;
`;

export const DropdownPanel = styled.div`
  position: absolute;
  bottom: 0;
  left: 100%;
  z-index: 1000;
  width: 320px;
  background: var(--white);
  border: 1px solid var(--border-shadow);
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
  overflow: hidden;
`;

export const Wrapper = styled.div`
  width: 100%;
`;

export const NotificationList = styled.div`
  overflow-y: scroll;
  max-height: 400px;
  padding: 8px 0px;

  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    background-color: rgba(0, 0, 0, 0.05);
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 2px;
    -webkit-box-shadow: inset 0 0 0 rgba(0, 0, 0, 0.4);
    background-color: rgba(0, 0, 0, 0.15);
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0 white;
    border-radius: 0;
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

export const NotificationItem = styled.div`
  padding: 12px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: background 0.2s ease;
  display: flex;
  gap: 10px;
  align-items: flex-start;

  &:hover {
    background: rgba(0, 0, 0, 0.02);
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const UnreadDot = styled.div`
  width: 8px;
  height: 8px;
  min-width: 8px;
  border-radius: 50%;
  background: var(--brand-ideolo);
  margin-top: 4px;
  visibility: ${({ isUnread }) => (isUnread ? "visible" : "hidden")};
`;

export const NotificationContentWrapper = styled.div`
  flex: 1;
  min-width: 0;
`;

export const NotificationContent = styled.div`
  color: var(--black);
  font-size: 13px;
  line-height: 1.4;
  margin-bottom: 4px;
  font-weight: ${({ isUnread }) => (isUnread ? "600" : "400")};
`;

export const NotificationTime = styled.div`
  color: var(--gray);
  font-size: 11px;
`;

export const EmptyState = styled.div`
  padding: 24px 16px;
  text-align: center;
  color: var(--gray);
  font-size: 13px;
`;

export const EmptyMessage = styled.div`
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.4;
`;

export const EmptyTitle = styled.div`
  margin-top: 12px;
  font-weight: 500;
  font-size: 14px;
`;

export const MarkAllAsReadButton = styled.button`
  width: 100%;
  padding: 12px 16px;
  border: none;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  background: var(--content-box-bg);
  color: var(--brand-ideolo);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
  text-align: center;

  &:hover {
    background: rgba(0, 0, 0, 0.02);
  }

  &:disabled {
    color: var(--gray);
    cursor: wait;
    opacity: 0.5;
  }
`;
